import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/user-assignment/UserAssignmentAction";
import { CustomSelect, redirectToPages, UserType, UserTypeOptions } from "../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { PersonnelUsersPage } from "./personnel-users/PersonnelUsersPage";
import { TeacherUsersPage } from "./teacher-users/TeacherUsersPage";
import { StudentUsersPage } from "./student-users/StudentUsersPage";
import { ParentUsersPage } from "./parent-users/ParentUsersPage";

export function UserAssignmentPage({ history }) {
  const [userGroupId, setUserGroupId] = useState();
  const [userType, setUserType] = useState();

  // Getting curret state of UserAssignment from store (Redux)
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, userGroups } = useSelector(
    (state) => ({
      actionsLoading: state.userAssignment.actionsLoading,
      isSuccess: state.userAssignment.isSuccess,
      type: state.userAssignment.type,
      userGroups: state.userAssignment.userGroups
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getUserGroups());
    return () => dispatch(actions.cleanUserIds());
  }, [dispatch]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  const userTypeOptions = UserTypeOptions.filter(option => option.value !== UserType.System);
  
  return (
    <>
      <Card>
        {actionsLoading && <ModalProgressBar />}
        <CardHeader title="Kullanıcı Atama" />
        <CardBody>
          <div className="form-group row">
            <div className="col-3 mt-3">
              Kullanıcı Grubu <span>*</span>
            </div>
            <div className="col-4">
              <CustomSelect
                options={userGroups}
                onChange={option => {
                  if (userType) dispatch(actions.getUserIds(option.value, userType));
                  setUserGroupId(option.value);
                }}
              />
            </div>
          </div>

          <div className="form-group row">
            <div className="col-3 mt-3">
              Kullanıcı Türü <span>*</span>
            </div>
            <div className="col-4">
              <CustomSelect
                options={userTypeOptions}
                onChange={option => {
                  if (userGroupId) dispatch(actions.getUserIds(userGroupId, option.value));
                  setUserType(option.value);
                }}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      {
        userType === UserType.Personnel &&
        <PersonnelUsersPage
          history={history}
          userGroupId={userGroupId}
          userType={userType}
        />
      }
      {
        userType === UserType.Teacher &&
        <TeacherUsersPage
          history={history}
          userGroupId={userGroupId}
          userType={userType}
        />
      }
      {
        userType === UserType.Student &&
        <StudentUsersPage
          history={history}
          userGroupId={userGroupId}
          userType={userType}
        />
      }
      {
        userType === UserType.Parent &&
        <ParentUsersPage
          history={history}
          userGroupId={userGroupId}
          userType={userType}
        />
      }
    </>    
  );
}